// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_bulletn-blue":"#0079a7","_bulletn-blue-light":"#1f9bcc","root":"LiveBulletinLink_root__xtvXK","button":"LiveBulletinLink_button__krx9w"};